<template>
  <div
    ref="wrapper"
    class="calendar_settings_wrapper active"
  >
    <div>
      <div class="date-picker" />
      <div
        v-show="compareToPrevious"
        class="date-picker1"
      />
    </div>
    <div class="settings_controls">
      <div class="settings_controls_part mb_8">
        <custom-select
          v-model="dates.dateRange"
          :options="{
            'custom' : 'Custom Date Range',
            'last_week': 'Last Week',
            'last_month': 'Last Month',
            'last_7_days': 'Last 7 days',
            'last_30_days' : 'Last 30 Days',
          }"
          label="Report Date Range"
          width="full"
        />

        <div class="flex justify-between mb_8">
          <div class="daterange report">
            {{
              formattedDates.fromDate ? formattedDates.fromDate : 'Please select a date'
            }}
          </div>
          <div class="daterange report">
            {{
              formattedDates.toDate ? formattedDates.toDate : 'Please select a date'
            }}
          </div>
        </div>
        <small
          v-if="reportDateRangeError"
          class="text-danger"
        >{{ reportDateRangeError }}</small>
      </div>
      <div
        v-if="allowCompare"
        class="settings_controls_part compare_settings mb_12"
      >
        <custom-toggle
          v-model="compareToPrevious"
          label="Compare to Previous"
        />
        <div
          v-show="compareToPrevious"
          class="hide_custom mt_8"
        >
          <custom-select
            v-model="dates.compRange"
            :options="{
              'custom' : 'Custom Date Range',
              'previous_period': 'Previous Period',
              'previous_year': 'Previous Year'
            }"
            label="Report Compare Range"
            width="full"
            @changed="value => {updateCompDateRange(value)}"
          />

          <div class="flex justify-between mb_8">
            <div class="daterange compare">
              {{ formattedDates.compFromDate ? formattedDates.compFromDate : 'Please select a date' }}
            </div>
            <div class="daterange compare">
              {{ formattedDates.compToDate ? formattedDates.compToDate : 'Please select a date' }}
            </div>
          </div>

          <small
            v-if="compareDateRangeError"
            class="text-danger"
          >{{ compareDateRangeError }}</small>
        </div>
      </div>
      <div class="flex items-center settings_controls_btn">
        <button
          class="btn secondary_btn btn_md mr_8"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          class="btn primary_btn btn_md"
          @click="apply()"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import $ from 'jquery';
import CustomSelect from './CustomSelect.vue';
import CustomToggle from './CustomToggle.vue';

export default {
  components: {
    CustomSelect,
    CustomToggle
  },
  props: {
    dateRange: {
      type: String,
      default: '',
    },
    compRange: {
      type: String,
      default: '',
    },
    fromDate: {
      type: String,
      default: '',
    },
    toDate: {
      type: String,
      default: '',
    },
    compFromDate: {
      type: String,
      default: '',
    },
    compToDate: {
      type: String,
      default: '',
    },
    allowCompare: {
      type: Boolean,
      default: true,
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY'
    },
  },
  emits: [
    'close',
    'update:fromDate',
    'update:dateRange',
    'update:compRange',
    'update:toDate',
    'update:compFromDate',
    'update:compToDate'
  ],
  data() {
    return {
      showReportDateRanges: false,
      includeToday: false,
      compareToPrevious: false,
      showCompareDateRanges: false,
      reportDateRangeError: false,
      compareDateRangeError: false,
      dates: {
        dateRange: this.dateRange ?? 'custom',
        compRange: this.compRange ?? null,
        fromDate: this.fromDate ? moment(this.fromDate).format('YYYY-MM-DD') : '',
        toDate: this.toDate ? moment(this.toDate).format('YYYY-MM-DD') : '',
        compFromDate: this.compFromDate ? moment(this.compFromDate).format('YYYY-MM-DD') : '',
        compToDate: this.compToDate ? moment(this.compToDate).format('YYYY-MM-DD') : '',
      },
    }
  },
  computed: {
    numberOfMonths() {
      if ($(window).width() <= 1024) {
        return 1;
      } else {
        return 2;
      }
    },
    formattedDates() {
      return {
        fromDate: moment(this.dates.fromDate).isValid() ? moment(this.dates.fromDate).format(this.format) : null,
        toDate: moment(this.dates.toDate).isValid() ? moment(this.dates.toDate).format(this.format) : null,
        compFromDate: moment(this.dates.compFromDate).isValid() ? moment(this.dates.compFromDate).format(this.format) : null,
        compToDate: moment(this.dates.compToDate).isValid() ? moment(this.dates.compToDate).format(this.format) : null,
      }
    }
  },
  watch: {
    'dates.dateRange': {
      handler() {
        this.updateDateRange(this.dates.dateRange);
      }
    },
    'dates.compRange': {
      handler() {
        this.updateCompDateRange(this.dates.compRange);
      }
    },
    'dates.toDate': {
      handler() {
        if (this.dates.toDate !== '' && this.dates.compRange && this.dates.compRange !== 'custom') {
          this.updateCompDateRange(this.dates.compRange);
        }
      }
    },
    'compareToPrevious': {
      handler(a) {
        if (a === false) {
          this.dates.compRange = null;
          this.dates.compFromDate = '';
          this.dates.compToDate = '';
        } else {
          this.dates.compRange = this.compRange;
        }
      }
    }
  },
  mounted() {
    // Check if compare dates are passed in
    if ((this.compFromDate && this.compToDate) || this.compRange) this.compareToPrevious = true;
    $('.date-picker').datepicker('destroy');
    $('.date-picker1').datepicker('destroy');
    // Self required for datepicker functions
    let self = this;
    $(".date-picker").datepicker({
      firstDay: 1,
      dateFormat: 'yy-mm-dd',
      defaultDate: new Date(self.dates.fromDate),
      numberOfMonths: self.numberOfMonths,
      maxDate: 0,
      beforeShowDay: function (date) {
        // Loops through all dates on the calendar, determining if they should be highlighted.
        var fromDate = $.datepicker.parseDate('yy-mm-dd', self.dates.fromDate);
        var toDate = $.datepicker.parseDate('yy-mm-dd', self.dates.toDate);
        return [true, fromDate && ((date.getTime() === fromDate.getTime()) || (toDate && date >= fromDate && date <= toDate)) ? "dp-highlight" : ""];
      },
      onSelect: function (dateText) {
        // Set the range to 'custom' as the user is selecting dates on the calendar
        self.dates.dateRange = 'custom';
        // Parse the dates
        var fromDate = $.datepicker.parseDate('yy-mm-dd', self.dates.fromDate);
        var toDate = $.datepicker.parseDate('yy-mm-dd', self.dates.toDate);
        var selectedDate = $.datepicker.parseDate('yy-mm-dd', dateText);

        if (!fromDate || toDate) {
          // If its the first date, or if we're re-selecting, set the from date
          self.dates.fromDate = dateText;
          self.dates.toDate = '';
          $(this).datepicker();
        } else if (selectedDate < fromDate) {
          // If the selected date is less than the currently selected fromDate, switch them around
          self.dates.toDate = self.dates.fromDate;
          self.dates.fromDate = dateText;
          $(this).datepicker();
        } else {
          // Otherwise, it's the toDate
          self.dates.toDate = dateText;
          $(this).datepicker();
        }
        setTimeout(function () {
          // Add the additional class to the start and end of the range.
          self.highlightStartAndEndOfRange();
        }, 10);
      },
      onChangeMonthYear: function () {
        setTimeout(function () {
          // Add the additional class to the start and end of the range.
          self.highlightStartAndEndOfRange();
        }, 10);
      }
    });

    $(".date-picker1").datepicker({
      firstDay: 1,
      dateFormat: 'yy-mm-dd',
      defaultDate: new Date(self.dates.compFromDate),
      numberOfMonths: self.numberOfMonths,
      maxDate: 0,
      beforeShowDay: function (date) {
        // Loops through all dates on the calendar, determining if they should be highlighted.
        var fromDate = $.datepicker.parseDate('yy-mm-dd', self.dates.compFromDate);
        var toDate = $.datepicker.parseDate('yy-mm-dd', self.dates.compToDate);
        return [true, fromDate && ((date.getTime() === fromDate.getTime()) || (toDate && date >= fromDate && date <= toDate)) ? "dp-highlight1" : ""];
      },
      onSelect: function (dateText) {
        // Set the range to 'custom' as the user is selecting dates on the calendar
        self.dates.compRange = 'custom';
        // Parse the dates
        var fromDate = $.datepicker.parseDate('yy-mm-dd', self.dates.compFromDate);
        var toDate = $.datepicker.parseDate('yy-mm-dd', self.dates.compToDate);
        var selectedDate = $.datepicker.parseDate('yy-mm-dd', dateText);

        if (!fromDate || toDate) {
          // If its the first date, or if we're re-selecting, set the from date
          self.dates.compFromDate = dateText;
          self.dates.compToDate = "";
          $(this).datepicker();
        } else if (selectedDate < fromDate) {
          // If the selected date is less than the currently selected fromDate, switch them around
          self.dates.compToDate = self.dates.compFromDate;
          self.dates.compFromDate = dateText;
          $(this).datepicker();
        } else {
          // Otherwise, it's the toDate
          self.dates.compToDate = dateText;
          $(this).datepicker();
        }
        setTimeout(function () {
          // Add the additional class to the start and end of the range.
          self.highlightStartAndEndOfRange()
        }, 10);
      },
      onChangeMonthYear: function () {
        setTimeout(function () {
          // Add the additional class to the start and end of the range.
          self.highlightStartAndEndOfRange();
        }, 10);
      }
    });

    this.highlightStartAndEndOfRange();

  },
  methods: {
    updateDateRange(range) {
      this.dates.dateRange = range;
      switch (range) {
        case 'custom':
          break;
        case 'last_week':
          this.dates.fromDate = moment().subtract(7, 'd').startOf('isoWeek').format('YYYY-MM-DD');
          this.dates.toDate = moment().subtract(7, 'd').endOf('isoWeek').format('YYYY-MM-DD');
          break;
        case 'last_fortnight':
          this.dates.fromDate = moment().subtract(14, 'd').startOf('isoWeek').format('YYYY-MM-DD');
          this.dates.toDate = moment().subtract(7, 'd').endOf('isoWeek').format('YYYY-MM-DD');
          break;
        case 'last_month':
          this.dates.fromDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
          this.dates.toDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
          break;
        case 'last_7_days':
          this.dates.fromDate = moment().subtract(7, 'd').format('YYYY-MM-DD');
          this.dates.toDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
          break;
        case 'last_14_days':
          this.dates.fromDate = moment().subtract(14, 'd').format('YYYY-MM-DD');
          this.dates.toDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
          break;
        case 'last_30_days':
          this.dates.fromDate = moment().subtract(30, 'd').format('YYYY-MM-DD');
          this.dates.toDate = moment().subtract(1, 'd').format('YYYY-MM-DD');
          break;
      }
      $('.date-picker').datepicker('setDate', $.datepicker.parseDate('yy-mm-dd', this.dates.fromDate));
      $('.date-picker').datepicker('refresh');
      this.highlightStartAndEndOfRange();
    },

    updateCompDateRange(range) {
      this.dates.compRange = range;
      let diff = null;
      switch (range) {
        case 'custom':
          break;
        case 'previous_period':
          diff = moment(this.dates.toDate, 'YYYY-MM-DD').diff(moment(this.dates.fromDate, 'YYYY-MM-DD'), 'days');
          this.dates.compFromDate = moment(this.dates.fromDate, 'YYYY-MM-DD').subtract(diff + 1, 'd').format('YYYY-MM-DD');
          this.dates.compToDate = moment(this.dates.compFromDate, 'YYYY-MM-DD').add(diff, 'd').format('YYYY-MM-DD');
          break;
        case 'previous_month':
          this.dates.compFromDate = moment(this.dates.fromDate, 'YYYY-MM-DD').subtract(1, 'month').format('YYYY-MM-DD');
          this.dates.compToDate = moment(this.dates.toDate, 'YYYY-MM-DD').subtract(1, 'month').format('YYYY-MM-DD');
          break;
        case 'previous_year':
          this.dates.compFromDate = moment(this.dates.fromDate, 'YYYY-MM-DD').subtract(1, 'year').format('YYYY-MM-DD');
          this.dates.compToDate = moment(this.dates.toDate, 'YYYY-MM-DD').subtract(1, 'year').format('YYYY-MM-DD');
          break;
      }
      $('.date-picker1').datepicker('setDate', $.datepicker.parseDate('yy-mm-dd', this.dates.compFromDate));
      $('.date-picker1').datepicker('refresh');
      this.highlightStartAndEndOfRange();
    },

    highlightStartAndEndOfRange() {
      // TODO: replace with JS
      $('.start_range').removeClass('start_range');
      $('.dp-highlight').first().addClass('start_range');
      $('.dp-highlight').last().addClass('start_range');
      $('.dp-highlight1').first().addClass('start_range');
      $('.dp-highlight1').last().addClass('start_range');
    },

    validate() {
      // Assume validation will pass
      let validated = true;
      // Check that the report dates are valid
      if (!this.formattedDates.fromDate || !this.formattedDates.toDate) {
        this.reportDateRangeError = 'Please select a date range';
        validated = false;
      } else {
        this.reportDateRangeError = false;
      }
      // Check if there are comparison dates and that they are both valid
      if (this.compareToPrevious && (!this.formattedDates.compFromDate || !this.formattedDates.compToDate)) {
        this.compareDateRangeError = 'Please select a date range';
        validated = false;
      } else {
        this.compareDateRangeError = false;
      }
      return validated;
    },

    apply() {
      if (this.validate()) {
        this.$emit('update:fromDate', this.dates.fromDate);
        this.$emit('update:dateRange', this.dates.dateRange);
        this.$emit('update:compRange', this.dates.compRange);
        this.$emit('update:fromDate', this.dates.fromDate);
        this.$emit('update:toDate', this.dates.toDate);
        this.$emit('update:compFromDate', this.dates.compFromDate);
        this.$emit('update:compToDate', this.dates.compToDate);
        this.$emit('close');
      }
    },
  }

}
</script>

<style scoped>
.datepicker {
  border: none !important;
  padding: 0 !important;
  margin-bottom: 5px;
}

.daterange {
  width: calc(50% - .5rem);
  background-color: #fff;
  margin-right: 0;
  padding: 1rem;
  border-radius: 12px;
  height: 3rem;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.daterange.report {
  border: 1px solid #37B2A8;
}

.daterange.compare {
  border: 1px solid #FFD673;
}

.toggle_item {
  width: 64px;
  height: 36px;
  display: inline-block;
  cursor: pointer;
  margin-bottom: 0;
}

.toggle_item .slider {
  display: inline-block;
  border-radius: 40px;
  background-color: #D6D8E7;
  width: 100%;
  height: 100%;
  position: relative;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.toggle_item .slider:before {
  position: absolute;
  content: "";
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  border-radius: 40px;
  width: 2rem;
  height: 2rem;
  background-color: white;
  left: 2px;
  top: 50%;
  margin-top: -1rem;
}

</style>
